import React from 'react';
import './GapLegend.scss';

export interface GapLegendProps {
  visibilityLabel: string;
  /** Omit (or pass null) when no row has a cited value — the legend then shows visibility only. */
  citedLabel?: string | null;
}

/**
 * Card-footer legend for the `GapBar` sections (PlatformGapBars, CompetitorComparison): a separator line,
 * then dots in the two bar colors. Labels come translated from the section, so each keeps its own keys.
 */
export const GapLegend: React.FC<GapLegendProps> = ({ visibilityLabel, citedLabel }) => (
  <div className="gap-legend">
    <span className="gap-legend__item">
      <span className="gap-legend__dot gap-legend__dot--visibility" />
      {visibilityLabel}
    </span>
    {citedLabel && (
      <span className="gap-legend__item">
        <span className="gap-legend__dot gap-legend__dot--cited" />
        {citedLabel}
      </span>
    )}
  </div>
);

export default GapLegend;
